module.exports = __webpack_public_path__ + "media/images/icons/career-2a33c6f77475fb1f942cfd82c3622796.svg";